import type { Media, Theme } from '../../types/props.js'

export interface FeatureCardItem {
  /** 卡片标题 */
  title: string
  /** 卡片副标题/描述 */
  subtitle: string
  /** 背景图片 URL */
  image: Media
  /** 主题，默认 light */
  theme?: Theme
  /** 链接地址 */
  link?: string
}

export interface FeatureCardsProps {
  data: {
    /** 主标题 */
    title: string
    /** 副标题/描述 */
    subtitle?: string
    /** 卡片列表 */
    items: FeatureCardItem[]
    /** 主题，默认 light */
    theme?: Theme
  }
  /** 自定义类名 */
  className?: string
}
